import { createContext } from "react";
import type { MetadataStore } from "../MetadataProvider.types";

const MetadataStoreContext = createContext<MetadataStore | undefined>(undefined);
MetadataStoreContext.displayName = "MetadataStoreContext";

export default MetadataStoreContext;
